import { css } from '@emotion/react';
import { HydratedCallRecord } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records/v1/call_record.pb';
import { PhoneCallsApi } from '@frontend/api-phone-calls';
import { CachedAudioScrubber } from '@frontend/phone-panels';
import { useScopedAppFlagStore } from '@frontend/scope';
import { theme } from '@frontend/theme';

type Props = {
  call: HydratedCallRecord;
  callRecordingPath: string;
  isDemoAccount?: boolean;
};

export const CallRecordingSection = ({ call, callRecordingPath, isDemoAccount }: Props) => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const hasPrivateCommsFlag = getFeatureFlagValue('apply-phone-number-user-access-restriction');

  // There's no recording available in this case
  if (!isDemoAccount && hasPrivateCommsFlag && !call.downloadCallRecordingToken) {
    return null;
  }

  return (
    <div css={styles.wrapper} data-channel-id={call?.channelId ?? ''}>
      <CachedAudioScrubber
        filePath={callRecordingPath}
        queryFn={
          callRecordingPath || !hasPrivateCommsFlag
            ? undefined
            : async () => {
                try {
                  if (!call.channelId || !call.locationId || !call.downloadCallRecordingToken) {
                    throw new Error('Missing channelId or locationId or downloadCallRecordingToken');
                  }

                  const res = await PhoneCallsApi.getCallRecording({
                    channelId: call.channelId,
                    locationId: call.locationId,
                    token: call.downloadCallRecordingToken,
                  });
                  if (res.signedUrl) {
                    return fetch(res.signedUrl);
                  } else {
                    throw new Error('No signed URL available');
                  }
                } catch (error) {
                  console.error('Error fetching call recording:', error);
                  throw error;
                }
              }
        }
        mediaId={call?.channelId || ''}
      />
    </div>
  );
};

const styles = {
  wrapper: css`
    button {
      min-width: ${theme.spacing(3)};
      width: ${theme.spacing(3)};
      height: ${theme.spacing(3)};
      padding: ${theme.spacing(0)};
    }
  `,
};
